import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SvgIconComponent} from "@components/svg-icon/svg-icon.component";
import {AppCopy} from "@models/cms/app.model";

@Component({
  selector: 'app-round-trip-discount-alert',
  standalone: true,
  imports: [
    SvgIconComponent
  ],
  templateUrl: './round-trip-discount-alert.component.html',
  styleUrl: './round-trip-discount-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoundTripDiscountAlertComponent {

  @Input() appCopy: AppCopy | null;

  extended: boolean = false;

  toggleContent() {
    this.extended = !this.extended;
  }

}
